export enum Statuses {
    Submitted = '0E0DEB93-BEB2-E911-A9AD-000D3A258246',
    Draft = 'B2CB511C-CAD3-E911-A9CF-000D3A258246',
    Approved = '7EE5EFA4-F8B1-E911-A9AC-000D3A258246',
    PendingOnCustomer = 'D51A5B43-0DB2-E911-A9AC-000D3A258246',
    PendingSubmission ='1CB9C2C5-80E3-E911-A9FF-000D3A258246',
    PendingOnApplicantModification = 'C2D846E0-0CB2-E911-A9AC-000D3A258246',
    PendingOnApplicantModifications = '39fa8c96-09bf-ec11-adc6-00224883a184',
    Rejected = '674972BE-F8B1-E911-A9AC-000D3A258246',
    cancelled= 'a4b081e2-9b24-ea11-aa8a-000d3a258246'
}
